import { EVMChain, EvmContractName } from '@repo/types-client';

import { BaseAlchemyProvider } from '../providers';
import { contractMapping } from './contract-mapping';

export const getERC1155TokenSupply = async (
  collection: Capitalize<EvmContractName>,
  tokenId: string,
  chain: EVMChain,
): Promise<number> => {
  const collectionData =
    contractMapping[chain][
      collection as keyof (typeof contractMapping)[typeof chain]
    ];
  const { address, abi } = collectionData;
  return BaseAlchemyProvider.readContract({
    address,
    abi,
    functionName: 'totalSupply',
    args: [BigInt(tokenId)],
  });
};
